import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import Modal from "../../../components/salesUser/campaign/requestCoupon";

import { getServerDataWithTypes } from "../../../action/common_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import {
  SALES_USERS_DATA,
  STATE_LIST,
} from "../../../action/salesUser_action_types";

import SideBar from "../common/sideBar";
import { history } from "../../../history/history";
import Pagination from "../../common/Pagination";
import { endPoints } from "../../../config";
import NoData from "../common/NoData";
import http from "../../../util/http";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import { axiosInstnace, getAdminData } from "../../../util/util";
import { CommonModelImpl } from "../../admin/common/CommonModel";
import { axiosInstnace as Axios } from "../../../util/util";

class RequestCouponComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      totalRecords: 0,
      salesUsersData: [],
      showAddAdminPopup: false,
      showCreateClusterPopup: false,
      showUpdateAdminPopup: false,
      showDeletePopup: false,
      customer:"",
      msg: "",
      adminData: getAdminData(),
      selectedAdminId: "",
    };
  }


  componentDidUpdate(prevProps, prevState) {
    // check whether client has changed
    if (prevProps.client !== this.props.client) {
      this.fetchData(this.props.salesUsersData);
    }
  }

  //Fetch all admin
  getAllData = (skip) => {
    let { limit } = this.state;
    let page = skip / limit + 1;
    this.setState({ page }, () => {
      this.componentDidMount();
    });
  };

  //

  //Set data of admin to state
  componentWillReceiveProps = (nextProps) => {
    let { adminsData } = nextProps;
    if (adminsData) {
      let { allData, count } = adminsData;
      this.setState({
        adminsData: allData ? allData : [],
        totalRecord: count ? count : 0,
      });
    }
  };

  //Getting all sales User
  componentDidMount = () => {
    let { page } = this.state;
    
    this.getAllSalesUsers(page);
  };


  clearSearch = () => {
    window.location.reload(true);
  };

  //vj

  //Fetching all sales user bassed on page
  getAllSalesUsers = async(page) => {
    let { adminData } = this.state;
    let data = {
      email: adminData.email,
      page,
      customer: this.state.customer
    };
    let coupons = await axiosInstnace.post(endPoints.getCouponsRequested, data);
    this.setState({
      salesUsersData: coupons.data.data,
      totalRecords: coupons.data.count
    });
  };

  //Set sales user data to state
  componentWillReceiveProps = (nextProps) => {
    console.log("on Data receive", nextProps);
    let { salesUsersData } = nextProps;
    this.setState({
      salesUsersData:
        salesUsersData && salesUsersData.allSalesUsers
          ? salesUsersData.allSalesUsers
          : [],
      totalRecords:
        salesUsersData && salesUsersData.totalRecord
          ? salesUsersData.totalRecord
          : 0,
    });
  };

  //Show hide add admin popup
  showHideAddAdminPopup = () => {
    this.setState({
      showAddAdminPopup: !this.state.showAddAdminPopup,
    });
  };

  showHideCreateClusterPopup = () => {
    this.setState({
      showCreateClusterPopup: !this.state.showCreateClusterPopup,
    });
  };

  //Show hide add admin popup
  showHideUpdateAdminPopup = (adminId) => {
    //console.log(adminId);
    this.setState({
      selectedAdminId: adminId,
      showUpdateAdminPopup: !this.state.showUpdateAdminPopup,
    });
  };

  serverCalls = async (url, data) => {
    const response = await http.post(url, data);
    if (response && response.data.statusCode == 200) {
      this.componentDidMount();
    } else {
      this.props.showError(
        response ? response.data.message : "Something is wrong"
      );
    }
  };

  //Redirect to route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  //Return the table for sales user
  render() {
    let {
      salesUsersData,
      totalRecords,
      page,
      limit,
      showAddAdminPopup,
    } = this.state;
    let indexNum = (page - 1) * limit;
    return (
      <div className="dashboardContainer">
        <HeaderAdminpanel />

        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Coupon Management |
                <span className="breadcrumb-active fct-breadcrumb">
                  Coupons
                </span>
              </div>

             
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                   <tr>
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          value={this.state.customer}
                          name="Customer Email"
                          onChange={(e)=>{
                            this.setState({
                              ...this.state,
                              customer: e.target.value,
                            })
                          }}
                          placeholder="Enter Customer Email"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>

                   
                    <td>
                      <span className="print_btn">
                        <button onClick={this.componentDidMount}>Search</button>
                      </span>
                      <span className="print_btn mrgLft10px">
                        <button onClick={this.clearSearch}>Clear</button>
                      </span>
                    </td>
                  </tr>

                  {/*<tr>
                      <td colspan="5">

                      </td>
                    </tr>*/}
                </tbody>
              </table>
              {localStorage.getItem("adminRole") &&
                (localStorage.getItem("adminRole") === "salesUser" ||
                  localStorage.getItem("adminRole") === "stationAdmin") && (
                  <div className="search_camp">
                    <button
                      onClick={this.showHideAddAdminPopup}
                      className="search_camp_btn"
                    >
                      Add
                    </button>
                  </div>
                )}

            </div>

            <div
              className={
                salesUsersData.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                  <th>S.No</th>
                            <th>Coupon Request Date</th>
                            <th>Customer</th>
                            <th>Frequency</th>
                            <th>Coupon Type</th>
                            <th>Proposed Value</th>
                            <th>Coupon Code</th>
                            <th>Generated Coupon Type</th>
                            <th>Coupon Value</th>
                            <th>Coupon Expiry Date</th>
                            <th>Coupon Request ID</th>
                            
                  </tr>
                </thead>
                <tbody>
                  {salesUsersData.map((campaign, index) => {
                    indexNum++;
                    return (
                      <tr key={index}>
                                                 <td>{indexNum}</td>
                                <td>
                                  {moment(campaign.date).format("DD MMM YYYY")}
                                </td>
                                <td>{campaign.customer}</td>
                                <td>{campaign.frequency== 'multi'? 'Multiple': 'One Time'}</td>
                                <td>{campaign.coupontype}</td>
                                <td>{campaign.propValue}</td>
                                <td>{campaign.couponCode}</td>
                            <td>{campaign.generatedCouponType}</td>
                                <td>{campaign.couponValue}</td>
                                <td>{moment(campaign.expiryAt).format("DD MMM YYYY")}</td>
                                <td>{campaign._id}</td>

                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="paginationTable">
                {totalRecords > 10 && (
                  <Pagination
                    getAllData={this.getAllSalesUsers}
                    totalRecords={totalRecords}
                  />
                )}
              </div>
            </div>

            {salesUsersData.length === 0 ? <NoData /> : null}

            {showAddAdminPopup && (
              <Modal
              isShowing={true}
                hide={this.showHideAddAdminPopup}
                admin={this.state.adminData}
              />
            )}


            {/* {showCreateClusterPopup && 
          <CreateClusterComp
            hidePopup = {this.showHideCreateClusterPopup}
          />
        } */}
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
    salesUsersData: state.sales.get("salesUsersData"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSalesUsers: (url, data, type) =>
      dispatch(getServerDataWithTypes(url, data, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    getStateList: (url, data, type) =>
      dispatch(getServerDataWithTypes(url, data, type)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RequestCouponComp);



// WEBPACK FOOTER //
// ./web/components/admin/manageCoupon/createrequestCoupon.jsx